(() => {

    const SIDEBAR = document.querySelector('.sidebar')

    if(!SIDEBAR) return;

    SIDEBAR.querySelector('.trigger').addEventListener('click', () => {
        SIDEBAR.classList.toggle('open')
    })


})()
